import { AppNavListItem } from '@m/alchemy-ui/AppNavListItem';
import { AppMenuListItem } from '@m/alchemy-ui/AppMenuListItem';
import { Item } from './Nav.styled';

interface MenuItemProps {
  label: string;
  url: string;
  keyName: string;
  icon: string | null;
  isActive: boolean;
  isMobileMenu?: boolean;
  showIndicator?: boolean;
}

const MenuItem = ({
  label,
  url,
  keyName,
  icon,
  isActive,
  isMobileMenu,
}: MenuItemProps) => {
  const ItemComponent = isMobileMenu ? AppMenuListItem : AppNavListItem;

  return (
    <ItemComponent isActive={isActive}>
      <Item href={url} key={keyName}>
        {icon && <i className={`fa fa-${icon}`} />}
        {label}
      </Item>
    </ItemComponent>
  );
};

export default MenuItem;
